import React from 'react';
import { Button } from 'react-bootstrap';
import Papa from 'papaparse';

function createCsvFileInBrowser(data) {
    try {
        const headers = [
            'Community Name',
            'Population',
            'Policy Type',
            'Policy Subtype',
            'Notes',
            'Met Council Community Link',
            'Policy Link',
            'More Information'
        ];

        // Map your data to match the expected structure
        const transformedData = data.map(row => ({
            'Community Name': row.name,
            Population: row.pop20,
            'Policy Type': row.category,
            'Policy Subtype': row.subcat,
            Notes: row.notes,
            'Met Council Community Link': row.mc_link,
            'Policy Link': row.plcy_link,
            'More Information': row.mc_desc,
        }));

        // Convert to CSV using PapaParse
        const csv = Papa.unparse(transformedData, {
            columns: headers,
        });

        // Create a Blob and trigger download
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const filename = 'policyfinder-export.csv';

        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log(`CSV download triggered: ${filename}`);
    } catch (error) {
        console.error('Error generating CSV in browser:', error);
    }
}

function ExportCsv({ tableData, isTableView = false }) {
    if (isTableView) {
        return (
            <Button variant="success" onClick={() => createCsvFileInBrowser(tableData)}>
                Export CSV
            </Button>
        );
    }
    
    return (
        <button onClick={() => createCsvFileInBrowser(tableData)}>
            Export Data
        </button>
    );
}

export default ExportCsv;